export default "__VITE_ASSET__BOHu7Cen__"